import React, { useState, useRef } from "react";
import classes from "./ProfilePicture.module.css";
import { user } from "../../constant";
import Button from "../Button";

const ProfilePicture = ({ value = user, onChange }) => {
  const fileInputRef = useRef(null);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onChange(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemove = () => {
    onChange(user); // Reset to default user image
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  return (
    <section>
      <div className={classes.bg}>
        <div className={classes.profileWrapper}>
          <span className={classes.circleFrame}>
            <img src={value ? value : user} alt="user" />
          </span>

          <div className={classes.ctaWrapper}>
            <Button label="Remove" variant="secondary" onClick={handleRemove} />
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleImageUpload}
              accept="image/*"
              style={{ display: "none" }}
            />
            <Button
              label="Upload Photo"
              variant="primary"
              onClick={triggerFileInput}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfilePicture;
